import { BaseModal, ModalCloseCross, type BaseModalProps } from "./BaseModal";

interface ModalConfirmarProps extends BaseModalProps {
	readonly title?: string;
	readonly message?: string;
	readonly onConfirm: () => void;
	readonly confirmText?: string;
	readonly cancelText?: string;
}
export function ModalConfirmar(props: ModalConfirmarProps) {
	return (
		<BaseModal show={props.show} close={props.close}>
			<div className="modal-header">
				{props.title && <h5 className="modal-title">{props.title}</h5>}
				<ModalCloseCross onClick={props.close} />
			</div>
			{props.message && <div className="modal-body">
				<p>{props.message}</p>
			</div>}
			<div className="modal-footer">
				<button type="button" className="btnSecondary" onClick={props.close}>{props.cancelText ?? "Cancelar"}</button>
				<button type="button" className="btnPrimary" onClick={props.onConfirm}>{props.confirmText ?? "Confirmar"}</button>
			</div>
		</BaseModal>
	);
}